(() => {
  const separator = " - ";
  const variantStrings = window.variantStrings || {};

  const normalize = (value) => (value || "").replace(/\s+/g, " ").trim();

  const getPriceText = (form) => {
    if (!form || !form.id) return "";

    const sectionId = form.id.replace("product-form-", "");
    const priceRoot = document.getElementById(`price-${sectionId}`);
    if (!priceRoot) return "";

    const activePrice =
      priceRoot.querySelector(".price__regular .price.special-price") ||
      priceRoot.querySelector(".price__regular .price");

    return normalize(activePrice ? activePrice.textContent : "");
  };

  const getBaseLabel = (textNode) => {
    const current = normalize(textNode.dataset.baseLabel || textNode.textContent);
    if (current) return current;
    return normalize(variantStrings.addToCart) || "Add to cart";
  };

  const shouldShowPrice = (label) => {
    const normalized = normalize(label);
    return (
      normalized !== normalize(variantStrings.soldOut) &&
      normalized !== normalize(variantStrings.unavailable)
    );
  };

  const syncFormButton = (form) => {
    const button = form.querySelector('button[type="submit"][name="add"]');
    const textNode = button ? button.querySelector("[data-add-to-cart-text]") : null;
    if (!button || !textNode) return;

    const labelText = normalize(textNode.textContent);

    if (
      labelText === normalize(variantStrings.addToCart) ||
      labelText === normalize(variantStrings.preOrder) ||
      labelText === normalize(variantStrings.soldOut) ||
      labelText === normalize(variantStrings.unavailable)
    ) {
      textNode.dataset.baseLabel = labelText;
    }

    const baseLabel = getBaseLabel(textNode);
    if (!shouldShowPrice(baseLabel)) {
      if (textNode.textContent !== baseLabel) {
        textNode.textContent = baseLabel;
      }
      return;
    }

    const priceText = getPriceText(form);
    const nextText = priceText ? `${baseLabel}${separator}${priceText}` : baseLabel;

    if (normalize(textNode.textContent) !== normalize(nextText)) {
      textNode.textContent = nextText;
    }
  };

  const initForm = (form) => {
    if (!form || form.dataset.addToCartPriceReady === "true") return;

    const textNode = form.querySelector("[data-add-to-cart-text]");
    if (!textNode) return;

    form.dataset.addToCartPriceReady = "true";
    textNode.dataset.baseLabel = normalize(textNode.textContent);

    const resync = () => {
      window.requestAnimationFrame(() => syncFormButton(form));
    };

    const textObserver = new MutationObserver(resync);
    textObserver.observe(textNode, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    const sectionId = form.id.replace("product-form-", "");
    const priceRoot = document.getElementById(`price-${sectionId}`);

    if (priceRoot) {
      const priceObserver = new MutationObserver(resync);
      priceObserver.observe(priceRoot, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }

    resync();
  };

  const initAll = (root = document) => {
    root.querySelectorAll('form[id^="product-form-"]').forEach((form) => initForm(form));
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAll());
  } else {
    initAll();
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;
        if (node.matches && node.matches('form[id^="product-form-"]')) {
          initForm(node);
          return;
        }
        initAll(node);
      });
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
